export default __webpack_public_path__ + "static/media/clock.71ccfd00.svg";